import { useCallback, useEffect, useState } from "react";

const useTimer = () => {
  const [timerId, setTimerId] = useState(-1);
  const [countdown, setCountdown] = useState(0);

  const clear = useCallback(() => {
    timerId !== -1 && clearTimeout(timerId);
  }, [timerId]);

  useEffect(() => {
    return () => {
      clear();
      setCountdown(0);
    };
  }, [clear]);

  const start = ({ second, onTimeout }) => {
    clear();
    let remindSeconds = second;
    setCountdown(remindSeconds);
    const id = setInterval(() => {
      remindSeconds -= 1;
      setCountdown(remindSeconds);
      if (remindSeconds <= 0) {
        clear();
        onTimeout && onTimeout();
      }
    }, 1000);
    setTimerId(id);
    return id;
  };

  return {
    startTimer: start,
    clearTimer: clear,
    countdown,
  };
};

export default useTimer;
